import * as React from "react";
import { Text, TagLabel, useLocalVariant } from "@draftkings/arena-web";
import { mapCombinationStatusToVariant } from "../_localVariants";
export const Status = React.memo(function Status(props) {
    const { statusEntity } = props;
    const statusTagVariant = useLocalVariant("tagLabel", {
        $extendFromVariant: mapCombinationStatusToVariant[statusEntity.status],
        root: {
            display: "inline-block",
            width: "$s1",
            height: "$s1",
            marginRight: "$s0",
            borderRadius: "2px",
        }
    });
    const statusTextVariant = useLocalVariant("text", {
        root: {
            marginRight: "$s1",
            fontWeight: "400",
            fontSize: "8px",
            lineHeight: "12px"
        }
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(TagLabel, { testId: "combination-status-tag", as: "span", variant: statusTagVariant }),
        React.createElement(Text, { testId: "combination-status-text", as: "span", variant: statusTextVariant }, statusEntity.name)));
});
//# sourceMappingURL=Status.js.map